// QUÉ HOJAS SE OFRECEN Y CUÁL VIENE ELEGIDA · U-02 fase a (DISEÑO §6.1).
//
// `GET /api/qr/formatos-etiqueta` devuelve TODAS las hojas, también las
// retiradas (`activo: false`): quitar una de esa lista habría cambiado un
// contrato que ya se consume. Así que el filtro vive aquí, en la pantalla.
//
// LA ELEGIDA LA DICE EL SERVIDOR (`predeterminado`), no una constante. La
// constante de antes era `24_CARTA`, que es justo la hoja que no cabía en
// una carta y perdía la última fila: elegirla por omisión era imprimir mal
// a quien no tocaba nada.
//
// Un servidor anterior a la 251 no manda `activo` ni `predeterminado`: sin
// la clave, la hoja se ofrece y se elige la primera. Así una pestaña
// abierta con la versión vieja del servidor sigue funcionando igual.

/** Las hojas que se ofrecen: todas menos las retiradas. */
export function hojasOfrecidas(formatos) {
  return (formatos || []).filter((f) => f && f.activo !== false);
}

/** El código de la hoja que viene elegida: la predeterminada, o la primera. */
export function hojaInicial(ofrecidas) {
  const lista = ofrecidas || [];
  const pred = lista.find((f) => f.predeterminado === true);
  return (pred ?? lista[0])?.codigo ?? null;
}

/** ¿Hay que avisar de que sus medidas no se comprobaron con una hoja comprada? */
export function sinConfirmar(formato) {
  return Boolean(formato) && formato.medidas_confirmadas === false;
}

// U-02 fase d (DISEÑO §6.1): el archivo ZPL solo se ofrece con una hoja de
// ROLLO elegida (`para_rollo`, que manda el servidor desde la fase a). Con
// carta o A4 no se enseña: no se muestra un control que no sirve. Un
// servidor anterior que no mande la clave no ofrece ZPL.
/** ¿Se ofrece bajar el archivo ZPL para esta hoja? */
export function ofreceZpl(formato) {
  return Boolean(formato) && formato.para_rollo === true;
}

/** Resoluciones que admite el servidor; la primera es la de por omisión. */
export const RESOLUCIONES_ZPL = [203, 300];
